<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
   
    <div class="top_bg">
      <div class="container_box">
        <div style="font-size: 50px;">店务系统介绍</div>
        <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">店务SAAS一站式服务、尊享智慧美业新时代</div>
      </div>
    </div>
    <div class="second_bg">
      <div style="margin:0 auto;display: flex;align-items: center;width: 1200px;padding-top: 249px;">
        <div class="left_img">
          <img src="../../static/img/ed.png" alt="" style="width:100%;height: 100%;">
        </div>
        <div>
          <div class="top_show">关于店务系统的简介</div>
          <div class="word_box" style="height:140px">
            <div class="word_in">
              找美网SAAS支持IOS、Android、Web全平台齐全端到端SDK，服务全球多个国家和地区，致力于为美业提供多渠道电商解决方案，通过自建商城，以及营销系统、分销系            
            </div>
          </div>
          <div class="word_box" style="margin-top: 20px;">
            <div class="word_in">
              统、会员系统、店务管理帮助企业搭建新一代商城销售、管理、引流体系，快速实现去中心化流量聚合，客户粉丝沉淀，助力企业快速步入移动电商时代。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle_big">
      <div class="middle_box">
        <div class="middle_div">
          <div class="middle_img"><img src="../../static/img/website.png" alt=""></div>
          <div class="middle_text">
            <div class="middle_text1">找美网店务系统WEB端</div>
            <div class="middle_text2">专业的美业SaaS,实现数据化经营，提高管理效率，为美业店家提供数字化和智能化的解决方案</div>
            <div class="time_box">
              <div class="year">2017.09</div>
              <!-- <div class="month">09</div> -->
            </div>
          </div>
        </div>
        <div class="middle_div">
          <div class="middle_img"><img src="../../static/img/app.png" alt=""></div>
          <div class="middle_text">
            <div class="middle_text1">找美网店务系统APP端</div>
            <div class="middle_text2">拥有会员管理、资产查询、沟通记录、需求标签等功能，便于精准有效回访顾客，提高客户粘性和到店率</div>
            <div class="time_box">
              <div class="year">2018.03</div>
              <!-- <div>03</div> -->
            </div>
          </div>
        </div>
        <div class="middle_div">
          <div class="middle_img"><img src="../../static/img/gkcd.png" alt=""></div>
          <div class="middle_text">
            <div class="middle_text1">找美网店务系统顾客C端</div>
            <div class="middle_text2">实现在线预约、资产查询、便捷支付等一系列功能，让顾客避免线下电话预约的繁琐，实现轻松耗卡</div>
            <div class="time_box">
              <div class="year">2018.05</div>
              <!-- <div>05</div> -->
            </div>
          </div>
        </div>
        <div class="middle_div">
          <div class="middle_img"><img src="../../static/img/tk.png" alt=""></div>
          <div class="middle_text">
            <div class="middle_text1">找美网店务系统拓客商城</div>
            <div class="middle_text2">利用灵活多样的拓客模式，如：分销、限时购、积分兑换、砍价等，加速产品项目推广，实现可持续裂变</div>
            <div class="time_box">
              <div class="year">2017.01</div>
              <!-- <div>04</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员管理系统 -->
    <div style="background: white;width: 100%;margin-bottom: 78px;">
      <div style="font-size: 30px;color: #000;font-weight:600;text-align: center;margin-top: 59px">
        会员管理系统
      </div>
      <div class="second_text">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div style="font-size: 18px;color: #838383;text-align: center;margin-top: 19px">
        一站式会员管理·智能化管理系统，深度了解顾客信息，明细消耗资产、细化会员画像。</div>
      <div class="member_box">
        <div style="width: 657px;height: 657px;margin: 0 auto;position: relative;">
          <img src="../../static/img/circle.png" alt="" style="width: 100%;height: 100%;">
          <span style="font-size: 35px;color: #fff;position: absolute;top: 305px;left: 235px">会员管理系统</span>
          <span style="font-size: 24px ;color: #030303;top:180px;left: 65px;position: absolute">私密档案</span>
          <span style="font-size: 24px ;color: #030303;top:110px;right: 65px;position: absolute">需求分析</span>
          <span style="font-size: 24px ;color: #030303;bottom:110px;left: 90px;position: absolute">沟通回访</span>
          <span style="font-size: 24px ;color: #030303;bottom:125px;right: 75px;position: absolute">会员分类</span>
        </div>
        <span class="member_des">全面掌握会员精密信息， 为大业绩开发奠定基础， 让业绩暴涨</span>
        <span class="member_des1">提升沟通成效， 提高服务质量， 增强会员粘性， 防止会员流失</span>
        <span class="member_des2">系统根据会员消费习惯， 自动分析归类， 从而做到精准营销</span>
        <span class="member_des3">对会员进行标签分类， 建立私域流量池， 便于管理挖掘会员 </span>
      </div>
    </div>
    <!-- 美业管理体系 -->
    <div style="background:rgba(248,249,253,1);width: 100%;padding-bottom: 100px;height: 700px;">
      <div style="font-size: 31px;color: #000;text-align: center;padding-top:37px;font-weight: 600;">美业管理体系</div>
      <div class="second_text">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div style="font-size: 18px;color: #838383;text-align: center;margin-top: 18px;">高效率管理模式·系统化管理体系，员工、权限、提成、业绩一清二楚。
      </div>
      <div style="display: flex;margin:0 auto;padding-top: 70px;width: 1200px;">
        <div>
          <div style="width:44px;height: 44px">
            <img src="../../static/img/shop.png" alt="" style="width: 100%;height: 100%;">
          </div>
          <div style="display: flex;align-items: flex-start;margin-top: 28px;">
            <div class="rate"></div>
            <div style="margin-left: 9px;margin-top: 20px;">
              <div class="rates">员工管理</div>
              <div class="rated">全方位信息化管理每一位员工，轻松掌握员工情况、工作汇报、近期业绩</div>
            </div>
          </div>
          <div style="display: flex;align-items: flex-start;margin-top: 24px;">
            <div class="rate"></div>
            <div style="margin-left: 9px;margin-top: 20px;">
              <div class="rates">门店管理</div>
              <div class="rated">帮助老板掌控门店运营情况，时刻掌握员工每日的工作进度及完成情况</div>
            </div>
          </div>
          <div style="display: flex;align-items: flex-start;margin-top: 24px;">
            <div class="rate"></div>
            <div style="margin-left: 9px;margin-top: 20px;">
              <div class="rates">权限管理</div>
              <div class="rated">根据不同的角色赋予相对应的管理权限，使每个角色都能发挥最大的作用</div>
            </div>
          </div>
          <div style="display: flex;align-items: flex-start;margin-top: 24px;">
            <div class="rate"></div>
            <div style="margin-left: 9px;margin-top: 20px;">
              <div class="rates">连锁管理</div>
              <div class="rated">全面的员工管理工具，实现连锁高效经营，随时查看所有门店动态详情</div>
            </div>
          </div>
        </div>
        <div class="rate_img">
          <img src="../../static/img/01.png" alt="" style="width: 100%;height: 100%;">
        </div>
      </div>
    </div>
    <!-- part one -->
    <div style="background-color: #fff;width: 100%;position: relative;">
      <div style="font-size: 30px;color: #000;font-weight:600;text-align: center;margin-top: 60px">
        美业管理体系
      </div>
      <div class="second_text">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div style="font-size: 18px;color: #838383;text-align: center;margin-top: 18px;">
        一站式会员管理·智能化管理系统，深度了解顾客信息，明细消耗资产、细化会员画像</div>
      <div style="display: flex;align-items: center;width: 1200px;margin: 0 auto;">
        <div style="margin-top: 100px;">
          <div>
            <div>
              <div style="display: flex;align-items: center">
                <div class="right_text" style="margin-right: 36px;">会员分类</div>
                <div class="right_imgs">
                  <img src="../../static/img/line.png" alt="">
                </div>
              </div>
              <div class="right_text2">全方位信息化管理每一位员工，轻松掌握员工情况、工作汇报、近期业绩</div>
            </div>
          </div>
          <div style="margin-top: 50px;">
            <div>
              <div style="display: flex;align-items: center">
                <div class="right_text" style="margin-right: 110px;">需求分析</div>
                <div class="right_imgs">
                  <img src="../../static/img/line.png" alt="">
                </div>
              </div>
              <div class="right_text2">系统根据会员消费习惯，自动分析归类，从而做到精准营销</div>
            </div>
          </div>
          <div style="margin-top: 50px;">
            <div>
              <div style="display: flex;align-items: center">
                <div class="right_text" style="margin-right: 150px;">私密档案</div>
                <div class="right_imgs">
                  <img src="../../static/img/line.png" alt="">
                </div>
              </div>
              <div class="right_text2">全面掌握会员精密信息，为大业绩开发奠定基础，让业绩暴涨</div>
            </div>
          </div>
          <div style="margin-top: 50px;margin-bottom: 60px;">
            <div>
              <div style="display: flex;align-items: center">
                <div class="right_text" style="margin-right: 200px;">沟通回访</div>
                <div class="right_imgs">
                  <img src="../../static/img/line.png" alt="">
                </div>
              </div>
              <div class="right_text2">提升沟通成效，提高服务质量，增强会员粘性，防止会员流失</div>
            </div>
          </div>
        </div>
        <div class="phone" style="width: 605px;height: 534px;margin-left: -70px;margin-top: 30px;">
          <img src="../../static/img/phone_img.png" alt="" style="width: 100%;height: 100%;">
        </div>
      </div>

    </div>
    <!-- 客户反馈 -->
    <div style="background-color: #F8F9FD;width: 100%;">
      <div style="font-size: 30px;;text-align: center;color: #000;font-weight: 600;padding-top: 48px;">客户反馈</div>
      <div class="second_text">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <!-- 三角形的布局已隐藏 -->
      <!-- <div class="all_bg">
        <div class="change_bg">
          <div class="top_img">
            <img src="../../static/img/13.png" alt="">
            <div class="triangle_up"></div>
          </div>
          <div class="change_one">
            <div class="group_name">御玫瑰健康美肤</div>
            <div class="group_line"></div>
            <div class="group_intro">以“新娘美容”为核心，延伸至孕妇和婴 幼儿的护肤保养，帮助千千万万爱美女 性实现“天然护肤，美丽蝶变”的梦想。</div>
          </div>
        </div>
        <div class="change_bg">
          <div class="change_one">
            <div class="group_name">御玫瑰健康美肤</div>
            <div class="group_line"></div>
            <div class="group_intro">以“新娘美容”为核心，延伸至孕妇和婴 幼儿的护肤保养，帮助千千万万爱美女 性实现“天然护肤，美丽蝶变”的梦想。</div>
          </div>
          <div class="top_img">
            <img src="../../static/img/8.png" alt="">
            <div class="triangle_down"></div>
          </div>
        </div>
        <div class="change_bg">
          <div class="top_img">
            <img src="../../static/img/10.png" alt="">
            <div class="triangle_up"></div>
          </div>
          <div class="change_one">
            <div class="group_name">御玫瑰健康美肤</div>
            <div class="group_line"></div>
            <div class="group_intro">以“新娘美容”为核心，延伸至孕妇和婴 幼儿的护肤保养，帮助千千万万爱美女 性实现“天然护肤，美丽蝶变”的梦想。</div>
          </div>
        </div>
        <div class="change_bg">
          <div class="change_one">
            <div class="group_name">御玫瑰健康美肤</div>
            <div class="group_line"></div>
            <div class="group_intro">以“新娘美容”为核心，延伸至孕妇和婴 幼儿的护肤保养，帮助千千万万爱美女 性实现“天然护肤，美丽蝶变”的梦想。</div>
          </div>
          <div class="top_img">
            <img src="../../static/img/11.png" alt="">
            <div class="triangle_down"></div>
          </div>
        </div>
      </div> -->
      <!-- 现有的布局 -->
      <div style="width: 1300px;height: 600px;margin: 0 auto;padding-bottom: 70px;">
        <div style="width:1200px;height:504px;padding-top:72px;margin: 0 auto;">
          <el-carousel height="504px" indicator-position="outside">
            <el-carousel-item>
              <div class="dianwu_box">
                <div class="store_img">
                  <img src="../../static/img/YSM.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">一生美</div>
                      <div class="area">·浙江</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      以“新娘美容”为核心，延伸至孕妇和婴幼儿的护肤保养，帮助千千万万爱美女性实现“天然护肤，美丽蝶变”的梦想。！
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，我们建立电子档案本，根据会员消费习惯，对会员进行需求标签分类，并建立门店‘私域流量池’，便于管理挖掘会员”
                    </p>
                  </div>
                </div>
              </div>
              <div class="dianwu_box" style="margin-left: 48px;">
                <div class="store_img">
                  <img src="../../static/img/YMG.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">御玫瑰健康美肤</div>
                      <div class="area">·广州</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      一家集美容护肤、经络养生、教育培训为一体的全国直营美容连锁机构，一直秉持 “做好每一次手法，服务好每一个客户”的经营理念。
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，我们通过微信公众号、小程序、供应链，发布限时秒杀、办卡优惠、促销活动等营销详情给顾客，引导消费习惯”
                    </p>
                  </div>
                </div>
              </div>
              <div class="dianwu_box" style="margin-left: 48px">
                <div class="store_img">
                  <img src="../../static/img/YH.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">雅红美容</div>
                      <div class="area">·佛山</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      主营美容、美体、生物抗衰、高端养生、完美身材管理等，一直以“给予美，收获爱”的理念，致力于打造女性健康、美丽、高品质生活的平台。
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，门店销售、采购、库存记录详情轻松查询，当库存不足时有预警提示，减少积压、控制成本，确保企业的资金流动”
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="dianwu_box">
                <div class="store_img">
                  <img src="../../static/img/YYMM.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">韵婴妈妈</div>
                      <div class="area">·惠州</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      一家集产后恢复、母乳喂养、亲子水育、小儿推拿、产品与系统开发，打造五维一体综合型的母婴护理连锁机构伴。
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，我们清楚知道门店的有效顾客、沉睡客、死客，根据顾客的不同状态做相应的跟进方案调整，减少流失率，提升消费频率”
                    </p>
                  </div>
                </div>
              </div>
              <div class="dianwu_box" style="margin-left: 48px;">
                <div class="store_img">
                  <img src="../../static/img/XSPA.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">行·SPA</div>
                      <div class="area">·广州</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      从创立起只与国内顶尖企业合作，引进行业顶尖项目，为客户的健康美丽保驾护航，秉承实现客户美丽蜕变，传播健康养生理念的初心！
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，我们帮助店家管理和分析门店的各类数据，这个功能解决了我们连锁门店的经营管理问题，大大节省了人力物力。”
                    </p>
                  </div>
                </div>
              </div>
              <div class="dianwu_box" style="margin-left: 48px">
                <div class="store_img">
                  <img src="../../static/img/AMKG.png" alt="">
                </div>
                <div class="store_container">
                  <div class="store_box">
                    <div class="text_box">
                      <div class="shop_name">爱美空间</div>
                      <div class="area">·东莞</div>
                    </div>
                  </div>
                  <div class="line_box">
                    <div class="line_style"></div>
                  </div>
                  <div class="shop_title">公司介绍</div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      专注于中医养生，为提升客户的健康水平不懈努力，提供一流的服务、合理的价格、优质的品牌形象与时尚感。
                    </p>
                  </div>
                  <div class="shop_detail">
                    <p class="shop_detail_text">
                      “通过找美网店务系统，智能的会员生日提醒、回访提醒、资产到期等提醒功能，非常贴心便于拓客，增加了会员到店消费的次数。”
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push('/')
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push('./home')
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push('./supplyChain')
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push('./marketingTools')
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push('./company')
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push('./channels')
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push('./contact')
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push('./culture')
      },
     //找美商学院-商学院文化
     goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {

    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .container_box {
    z-index: 10;
    position: absolute;
    top: 30%;
    left: 0;
    color: #fff;
    text-align: center;
    min-width: 769px;
    width: 100%;
  }

  .top_bg {
    background-image: url('../../static/img/sys_bg1.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 1004px;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .second_bg {
    background-image: url('../../static/img/sys_bg2.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 758px;
    z-index: 999;
    position: absolute;
    top: 607px
  }

  .left_img {
    width: 422px;
    height: 422px;

  }

  .top_show {
    margin-left: 66px;
    margin-bottom: 38px;
    font-size: 22px;
    color: #242424;
  }

  .word_box {
    width: 712px;
    height: 120px;
    background: rgba(255, 255, 255, 1);
    border: 1px dashed rgba(232, 68, 77, 1);
    margin-left: 66px;
  }

  .word_in {
    font-size: 16px;
    color: #606060;
    line-height: 35px;
    margin-top: 25px;
    margin-left: 55px;
    width: 600px;
  }

  .middle_big {
    width: 100%;
    height: 581px;
    background: #F3F6F9;
    /* margin-top: 607px; */
    margin-top: 350px;
  }

  .middle_box {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
  }

  .middle_div {
    height: 439px;
    width: 285px;
    margin-top: 81px;
  }

  .middle_img {
    width: 285px;
    height: 287px;
  }

  .middle_img img {
    width: 100%;
    height: 100%;
  }

  .middle_text {
    width: 285px;
    height: 152px;
    background: rgba(255, 255, 255, 1);
    position: relative;
  }

  .middle_text1 {
    font-size: 18px;
    color: #000;
    padding: 16px;
  }

  .middle_text2 {
    font-size: 14px;
    color: #6C6C6C;
    width: 168px;
    /* margin-top: 5px; */
    margin-left: 16px;
    line-height: 20px;
  }

  .time_box {
    width: 68px;
    height: 70px;
    position: absolute;
    top: 58px;
    right: 20px;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(228, 228, 228, 1);
    text-align: center;
    line-height: 21px;
  }

  .year {
    padding-top: 25px;
  }

  .member_box {
    /* width: 657px; */
    width: 1200px;
    height: 657px;
    margin: 0 auto;
    padding-top: 55px;
    position: relative;
    /* background: orange; */
  }

  .member_des {
    font-size: 18px;
    color: #A3A3A3;
    line-height: 31px;
    position: absolute;
    top: 206px;
    left: 100px;
    width: 194px;
    height: 93px;
  }

  .member_des1 {
    font-size: 18px;
    color: #A3A3A3;
    line-height: 31px;
    position: absolute;
    bottom: 75px;
    left: 213px;
    width: 130px;
    height: 124px;
  }

  .member_des2 {
    font-size: 18px;
    color: #A3A3A3;
    line-height: 31px;
    position: absolute;
    top: 135px;
    right: 97px;
    width: 194px;
    height: 93px;
  }

  .member_des3 {
    font-size: 18px;
    color: #A3A3A3;
    line-height: 31px;
    position: absolute;
    bottom: 95px;
    right: 110px;
    width: 194px;
    height: 93px;
  }

  .second_text {
    font-size: 20px;
    color: #4B4B4B;
    text-align: center;
    margin-top: 10px;
    font-weight: 500;
  }

  .rate {
    width: 11px;
    height: 11px;
    background-color: #0091FF;
    transform: rotate(45deg);
    margin-top: 28px;
  }

  .rates {
    font-size: 18px;
    color: #2F2F2F;
    font-weight: 500;
  }

  .rated {
    font-size: 14px;
    color: #626262;
    font-weight: 300;
    margin-top: 10px;
  }

  .rate_img {
    width: 601px;
    height: 365px;
    /* margin-top: 20px; */
    margin-top: 80px;
    margin-left: 129px;
  }

  .right_text {
    font-size: 16px;
    color: #2F2F2F;
  }

  .right_text2 {
    font-size: 14px;
    color: #626262;
  }

  .top_img {
    width: 300px;
    height: 200px;
    position: relative;
  }

  .top_img img {
    width: 100%;
    height: 100%;
  }

  .triangle_up {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 16px solid #fff;
    position: absolute;
    bottom: 0;
    left: 142px;
  }

  .triangle_down {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 16px solid #fff;
    position: absolute;
    top: 0;
    left: 142px;
  }

  .group_name {
    padding: 26px 87px;
    font-size: 18px;
  }

  .group_line {
    width: 30px;
    height: 1px;
    background-color: #666666;
    margin: 0 auto;
    margin-top: -10px
  }

  .group_intro {
    font-size: 14px;
    text-decoration: 25px;
    margin: 25px 30px;
    line-height: 25px;
  }

  .all_bg {
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    margin-top: 75px;
    background: #fff;
  }

  .change_bg {
    width: 300px;
    height: 400px;
    background: #fff;
    color: #807E82;
    overflow: hidden;
  }

  .change_bg:hover {
    background: orange;
    color: #fff;
  }

  .change_bg:hover .group_line {
    background-color: #fff;
  }

  .change_bg:hover .triangle_up {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 16px solid orange;
  }

  .change_bg:hover .triangle_down {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 16px solid orange;
  }

  .change_one {
    height: 200px;
    width: 300px
  }

  .dianwu_box {
    background: #fff;
    border-radius: 16px;
    width: 368px;
    height: 504px;
    float: left;
    border: 1px solid #eee;
    box-sizing: border-box;
  }

  .dianwu_box img {
    border-radius: 16px 16px 0 0;
    width: 368px;
    height: 208px
  }

  .store_img {
    width: 368px;
    height: 208px;
  }

  .store_img img {
    width: 100%;
    height: 100%;
  }

  .store_container {
    width: 368px;
    height: 296px;
  }

  .store_box {
    width: 200px;
    height: 28px;
    margin-left: 24px;
    margin-top: 16px;
  }

  .text_box {
    display: flex;
    align-items: center;
  }

  .shop_name {
    color: #222;
    font-size: 20px;
  }

  .area {
    font-size: 10px;
    color: #222
  }

  .line_box {
    padding-top: 15px;
    width: 320px;
    margin: 0 auto;
  }

  .line_style {
    width: 320px;
    height: 1px;
    background: #D8D8D8
  }

  .shop_title {
    margin-left: 24px;
    margin-top: 16px;
    font-size: 16px;
    color: #222
  }

  .shop_detail {
    width: 320px;
    height: 60px;
    margin-left: 24px;
    margin-top: 16px
  }

  .shop_detail_text {
    font-size: 14px;
    color: #7A7A7A;
    line-height: 20px
  }
</style>


// WEBPACK FOOTER //
// src/page/home.vue